import script from "./soc-report.vue?vue&type=script&setup=true&lang=js"
export * from "./soc-report.vue?vue&type=script&setup=true&lang=js"

import "./soc-report.vue?vue&type=style&index=0&id=c729f78e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c729f78e"]])

export default __exports__